import { get } from 'lodash';
import FilterDefinition from 'helpers/search_filters/filter_definition';

const buildSelector = path => query => get(query, `addressFilter.${path}`);

export const buildingNumber = new FilterDefinition({
  label: 'Building Number',
  value: buildSelector('buildingNumber')
});

export const cities = new FilterDefinition({
  label: 'City',
  value: buildSelector('cities')
});

export const currentCity = new FilterDefinition({
  label: 'City',
  value: buildSelector('currentCity')
});

export const state = new FilterDefinition({
  label: 'State',
  value: buildSelector('state')
});

export const zip = new FilterDefinition({
  label: 'Zip',
  value: buildSelector('zip')
});

export const county = new FilterDefinition({
  label: 'County',
  value: buildSelector('county')
});

export const market = new FilterDefinition({
  label: 'Market',
  value: buildSelector('market')
});

export const subMarket = new FilterDefinition({
  label: 'Submarket',
  value: buildSelector('subMarket')
});

export const microMarket = new FilterDefinition({
  label: 'Micro Market',
  value: buildSelector('microMarket')
});

export default [
  buildingNumber,
  cities,
  currentCity,
  state,
  zip,
  county,
  market,
  subMarket,
  microMarket
];
